import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { createSelector } from '@ngrx/store';
import { createFeatureSelector } from '@ngrx/store';
import { AdvertisersState } from 'app/modules/main/store/advertisers/advertisers.state';
import { AdvertiserAccount } from 'app/modules/main/models/account';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { first } from 'rxjs/operators';
import { filter } from 'rxjs/operators';
import { switchMap } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class AdvertisersSelectors {

  static readonly FEATURE = 'Advertisers';

  private readonly feature = createFeatureSelector<AdvertisersState>(
    AdvertisersSelectors.FEATURE
  );

  private readonly advertisers = createSelector(
    this.feature,
    (state: AdvertisersState) => state.advertisers
  );

  private readonly advertisersLoaded = createSelector(
    this.feature,
    (state: AdvertisersState) => state.advertisersLoaded
  );

  constructor(
    private readonly store: Store<AdvertisersState>
  ) {
  }

  public haveAdvertisersLoaded(): Observable<boolean> {
    return this.store.select(this.advertisersLoaded);
  }

  public onAdvertisersLoaded(): Observable<boolean> {

    return this.haveAdvertisersLoaded()
      .pipe(filter(x => !!x));
  }

  public getAdvertisers(): Observable<AdvertiserAccount[]> {

    return this.onAdvertisersLoaded()
      .pipe(switchMap(() => this.store.select(this.advertisers)));
  }

  public getAdvertiser(
    advertiserId: number
  ): Observable<AdvertiserAccount | undefined> {

    return this.onAdvertisersLoaded()
      .pipe(
        first(),
        switchMap(() => this.store.select(this.advertisers)),
        map(advertisers => advertisers.find(advertiser => advertiser.accountId === advertiserId)),
      );
  }

}
